import { createRouteDefintion, type RouteDefinition } from "./RouteDefinition";
import type { RouteTemplate } from "./RouteTemplate";
import type { UnknownQueryParam } from "./query/QueryStringParam";

export type PageRouteDefinition<RouteParameters, QueryParameters extends UnknownQueryParam[]> = RouteDefinition<RouteParameters, QueryParameters>;

export function createPageRoute<RouteParameters, QueryParams extends UnknownQueryParam[]>(relativeTemplate: RouteTemplate<RouteParameters>, queryParamDefinitions: [...QueryParams]): PageRouteDefinition<RouteParameters, QueryParams> {
    return createRouteDefintion({
        // This absoluteTemplate starts relative and will be completed by route segments adding prefixes later on
        absoluteTemplate: relativeTemplate,
        relativeTemplate: relativeTemplate,
        queryParameters: queryParamDefinitions,
    });
}
